export const environment = {
  apiUrl: 'https://vivavolei.api.qa.mutuaassessoria.com.br/api'
};
